import { setParam } from '@/routes/projectStages/issues/lib/issuesHelpers/setParam.ts'
import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'
import { SetURLSearchParams } from 'react-router-dom'

export function getAllNestedLocationsIds(
  locations: PopoverProperty[],
  locationsIds: string[] = [],
): string[] {
  for (const location of locations) {
    if (location.value.includes(`location`)) {
      locationsIds.push(location.value)
    }
    if (location.children) {
      getAllNestedLocationsIds(location.children, locationsIds)
    }
  }
  return locationsIds
}

export function handleSelectTopLevelLocation(
  selectedLocations: string[],
  allLocations: PopoverProperty[],
  setSearchParams: SetURLSearchParams,
) {
  // select / deselect all locations

  if (selectedLocations.length > 0) {
    return setParam('locations', `[]`, setSearchParams)
  }
  const all = getAllNestedLocationsIds(allLocations)

  const allString = JSON.stringify(all)

  return setParam(`locations`, allString, setSearchParams)
}

export function handleSelectNestedLocation(
  val: string,
  selectedLocations: string[],
  setSearchParams: SetURLSearchParams,
) {
  const joinedIdsString = val.replace(`all-locations-`, '')
  const locationsIds: string[] = joinedIdsString.split('.')

  let updated = [...selectedLocations]

  if (locationsIds.every(id => selectedLocations.includes(id))) {
    // console.log(`deselect`)
    updated = updated.filter(id => !locationsIds.includes(id))
  } else {
    // console.log(`select`)
    updated.push(...locationsIds)
  }

  const updatedJSON = JSON.stringify(updated)
  return setParam(`locations`, updatedJSON, setSearchParams)
}

export function findSelectedLocation(
  searchedId: string | undefined,
  locations: PopoverProperty[],
): PopoverProperty | null {
  if (!searchedId) return null

  for (const location of locations) {
    if (location.value === searchedId) {
      return location
    }

    if (location.children) {
      const found = findSelectedLocation(searchedId, location.children)
      if (found) return found
    }
  }
  return null
}
